import PropTypes from 'prop-types';
import { memo } from 'react';
// eslint-disable-next-line no-restricted-imports
import { FormattedDate as IntlFormattedDate } from 'react-intl';

import { APP_SETTINGS } from '../../app-settings';
import { useConfig } from '../../context/config-provider';

import { PatternFormattedDate } from './pattern-formatted-date';

function FormattedDateTimeUI({ value, format, ...props }) {
  const { site } = useConfig();

  const pattern = site?.dateTimePatterns?.[format];

  return pattern ? (
    <PatternFormattedDate pattern={pattern} value={value} />
  ) : (
    <IntlFormattedDate format={format} timeZone={APP_SETTINGS.TIMEZONE} value={value} {...props} />
  );
}

FormattedDateTimeUI.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  format: PropTypes.string.isRequired,
};

export const FormattedDateTime = memo(FormattedDateTimeUI);
